import React, { Component } from 'react';
import { UserDetailsBox, UserName } from '../style';
import { UserDetailsProps } from '../type';
import { Dropdown, Text, ExpandMoreIcon } from 'elmo-elements';

class UserDetails extends Component<UserDetailsProps> {
  static onClickLogout = () => {
    window.location.href = '/auth/logout';
  };

  render() {
    const { displayName, photo } = this.props;

    return (
      <UserDetailsBox>
        <UserName>{displayName}</UserName>
        <img src={photo} alt="userphoto" />
        <Dropdown icon={<ExpandMoreIcon />} ariaLabel="Logout">
          <Dropdown.Item
            ariaLabel="Option 1"
            value={1}
            onClick={UserDetails.onClickLogout}
            isDisabled={false}
          >
            <Text>Logout</Text>
          </Dropdown.Item>
        </Dropdown>
      </UserDetailsBox>
    );
  }
}

export default UserDetails;
